import { render, staticRenderFns } from "./TotalResultComponent.vue?vue&type=template&id=1e6cafcb&scoped=true&"
import script from "./TotalResultComponent.vue?vue&type=script&lang=js&"
export * from "./TotalResultComponent.vue?vue&type=script&lang=js&"
import style0 from "./TotalResultComponent.vue?vue&type=style&index=0&id=1e6cafcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6cafcb",
  null
  
)

export default component.exports